//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
import "../Diagramming/Diagramming.SheetElementBuilder.js";
import "../Diagramming/Diagramming.LocationBuilder.js";
import "../no/ugmath.js";
let d=[[[0,"Discipline",1,0],[0,"End",1,"Diagramming.Port",0],[1,"EndLocation",0,"Diagramming.LocationBuilder",0],[0,"ReverseEnd",0,0],[0,"Start",1,"Diagramming.Port",0],[1,"StartLocation",0,"Diagramming.LocationBuilder",0]],[[["num_points","points"],"GetBendPoints",{},0,0],[["points"],"SetBendPoints",{},1,0],[[],"GetShapeType",{R_:{shapeType:''}},0,0],[["shapeType"],"SetShapeType",{},1,0]],[]];
SPLM.Diagramming.ConnectionBuilder = class extends SPLM.Diagramming.SheetElementBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.ConnectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Diagramming.ConnectionBuilder.ShapeOption = Object.freeze({
    "Orthogonal" : "Orthogonal", "Quadratic" : "Quadratic", "Spline" : "Spline", "Arc" : "Arc"});

export default SPLM;